'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteLayout', ['$compile', '$controller', 'NotesQueryManagementService', 'TimeService', 'WorkPeriodStore', '$q', 'Session', function($compile, $controller, NotesQueryManagementService, TimeService, WorkPeriodStore, $q, Session) {
      /**
       * Generates a management ID for a particular module class.
       * @param  {string} namespace   String namespace of the current system context
       * @param  {string} moduleClass String key of the module class to generate for
       * @return {string}             UUID to use for the management ID
       */
      function generateManagementId(namespace, moduleClass) {
        var key = namespace + '-' + moduleClass;
        return {
          key: key,
          id: NotesQueryManagementService.getUniqueId(key)
        };
      }

      var moduleClasses = {
        'layout-module-banner': {
          initModule: function(input) {
            var M = lodash.merge({}, input);

            function generateHomeButton() {
              return '<span sa-note-modify-context action="home" class="pull-left"><div class="modify-context-click sa_button sa_icon_button sa_small sa_gray go-home-button"><i class="sa-icon-home left"></i> Home</div></span>';
            }

            function generateBannerComponent() {
              return '<div class="module-banner">' + M.text + '</div>';
            }

            M.setText = function(text) {
              M.text = text;
            };

            M.render = function() {
              return ((M.addHomeButton) ? generateHomeButton(): '') + generateBannerComponent();
            }

            return M;
          }
        },
        'layout-module-homebutton': {
          initModule: function(input) {
            var M = lodash.merge({}, input);

            function generateButtonComponent() {
              return '<span sa-note-modify-context class="home-button" action="' + M.action + '"><i class="modify-context-click ' + M.icon + '"></i><div class="text">' + M.text + '</div></span>';
            }

            M.setAction = function(action) {
              M.action = action;
            };

            M.setIcon = function(icon) {
              M.icon = icon;
            };

            M.setText = function(text) {
              M.text = text;
            };

            M.render = function() {
              return generateButtonComponent();
            };

            return M;
          }
        },
        'layout-module-weekselector': {
          initModule: function(input) {
            var M = lodash.merge({}, input);

            function generateThisWeekComponent() {
              return '<div sa-note-week-selector label="This Week" base-date="' + moment.utc().format() + '" show-days="true"></div>';
            }

            function generateNextWeekComponent() {
              return '<div sa-note-week-selector label="Next Week" base-date="' + moment.utc().add(7, 'days').format() + '"></div>';
            }

            M.render = function() {
              return generateThisWeekComponent() + generateNextWeekComponent();
            }

            return M;
          }
        },
        'layout-module-header': {
          initModule: function(input) {
            var M = lodash.merge({}, input);

            function generateHomeButton() {
              return '<span sa-note-modify-context action="home" class="pull-left"><div class="modify-context-click sa_button sa_icon_button sa_small sa_gray go-home-button"><i class="sa-icon-home left"></i> Home</div></span>';
            }

            function generateContextViewComponent() {
              return '<div sa-note-subject-view class="sa-note-subject-view-wrapper" management-id="' + M.queryManagementId + '"></div>';
            }

            M.setQueryManagementNameAndId = function(name, id) {
              M.queryManagementName = name;
              M.queryManagementId = id;
            };

            M.render = function() {
              return ((M.addHomeButton) ? generateHomeButton(): '') + generateContextViewComponent();
            };

            return M;
          }
        },
        'layout-module-create': {
          initModule: function(input) {
            var M = lodash.merge({}, input);

            M.state = {
              compacted: M.flags.initialCompactableState
            };

            function generateCreateComponent() {
              return '<div sa-note-create class="' + (M.isCompacted() ? ' sa-note-create-compact': '') + '" management-id="' + M.queryManagementId + '" sa-permission-required="notes.create" organization-id="current"></div>';
            }

            M.isCompacted = function() {
              return M.state.compacted;
            };

            M.setQueryManagementNameAndId = function(name, id) {
              M.queryManagementName = name;
              M.queryManagementId = id;
            };

            M.render = function() {
              return generateCreateComponent();
            };

            return M;
          }
        },
        'layout-module-queryresults': {
          initModule: function(input, moduleArrayIndex) {
            var M = lodash.merge({}, input);
            M.moduleArrayIndex = moduleArrayIndex;

            M.state = {
              isCollapsed: M.flags.initiallyCollapsed
            };

            M.toggleCollapse = function() {
              M.state.isCollapsed = !M.state.isCollapsed;
            };

            function generateTitleComponent() {
              var html = '';

              html += '<div class="layout-module-title clearfix" ng-click="layout.modules[' + M.moduleArrayIndex + '].toggleCollapse()">';
              html += '<div class="title-text pull-left">' + M.getTitle() + '</div>';
              if (M.isCollapsable()) {
                html += '<div class="arrow-rotation-container"><i class="sa-icon-arrow-down-solid"></i></div>';
              }
              html += '</div>';

              return html;
            }

            function generateQueryResultsComponent() {
              var html = '';

              if (M.isCollapsable()) {
                html += '<div class="partial-collapse" uib-collapse="layout.modules[' + M.moduleArrayIndex + '].state.isCollapsed">';
              }

              html += '<div sa-note-query-results query-name="' + M.queryManagementName + '" management-id="' + M.queryManagementId + '" hide-on-empty="' + M.hideOnEmpty().toString() + '"';

              if (M.onlyAllow()) {
                html += ' only-allow="' + M.onlyAllow() + '"';
              }

              html += '></div>';

              if (M.isCollapsable()) {
                html += '</div>';
              }

              return html;
            }

            M.setQueryManagementNameAndId = function(name, id) {
              M.queryManagementName = name;
              M.queryManagementId = id;
            };

            M.initSubscription = function(scope) {
              M.subscription = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});
              M.subscription.initialize(M.queryManagementName, M.queryManagementId);
              M.subscription.setRenderCallback(function() {});
            };

            M.setQuery = function(query) {
              M.subscription.setQuery(query);
            };

            M.getTitle = function() {
              return M.title;
            };

            M.isCompactable = function() {
              return !!M.flags.compactable;
            };

            M.isCollapsable = function() {
              return !!M.flags.collapsable;
            };

            M.hideOnEmpty = function() {
              return !!M.flags.hideOnEmpty;
            };

            M.onlyAllow = function() {
              return M.flags.onlyAllow;
            };

            M.render = function() {
              var html = '';

              html += '<div class="layout-module-queryresults"';

              if (M.isCollapsable()) {
                html += ' ng-class="{collapsed: layout.modules[' + M.moduleArrayIndex + '].state.isCollapsed}"';
              }

              html += '>';

              html += (generateTitleComponent() + generateQueryResultsComponent());

              html += '</div>';

              return html;
            };

            return M;
          }
        },
        'layout-module-template': {
          initModule: function(input) {
            var M = lodash.merge({}, input);

            M.render = function() {
              return '<div ng-include="\'' + M.templateUrl + '\'" style="height: inherit;"></div>';
            };

            return M;
          }
        }
      };

      var layoutClasses = {
        'layout-home': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-banner',
              flags: {
                requiredContainer: 'layout-home-top'
              },
              text: 'SmartNotes Home'
            }, {
              name: 'layout-module-banner',
              flags: {
                requiredContainer: 'layout-home-weekcontainers'
              },
              text: 'View Notes on...'
            }, {
              name: 'layout-module-weekselector',
              flags: {
                requiredContainer: 'layout-home-weekcontainers'
              }
            }, {
              name: 'layout-module-homebutton',
              flags: {
                requiredContainer: 'layout-home-buttons'
              },
              action: 'recent',
              icon: 'sa-icon-clock',
              text: 'Most Recent'
            }, {
              name: 'layout-module-homebutton',
              flags: {
                requiredContainer: 'layout-home-buttons'
              },
              action: 'learn',
              icon: 'fa fa-graduation-cap',
              // icon: 'fa fa-graduation-cap',
              text: 'Learn'
            }],
            layoutFlags: {
              containerClasses: {
                'layout-home-top': 'title'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            instance.update = function(newData) { /* ... */ };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-date': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-header',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              addHomeButton: true
            }, {
              name: 'layout-module-create',
              flags: {
                requiredContainer: 'layout-top-fixed',
                compactable: true,
                initialCompactableState: true
              }
            }, {
              // Date box
              name: 'layout-module-queryresults',
              title: 'Notes',
              flags: {
                collapsable: true,
                initiallyCollapsed: false,
                onlyAllow: 'date',
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              // Position box
              name: 'layout-module-queryresults',
              title: 'Notes on Positions',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'Position',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              name: 'layout-module-queryresults',
              title: 'Notes on Shifts',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'WorkPeriod',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              name: 'layout-module-queryresults',
              title: 'Notes on Users',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'User',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-fixed': 'overlay-measure',
                'layout-wrapper-queryresults': 'overlay-target',
                'layout-top-title': 'title overlay-measure'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            // Check for the required data
            if (!initData.date) {
              console.error('Layout Configuration {layout-date}: Required Data Missing: date');
              return null;
            }

            instance.state = {
              namespace: scope.namespace
            };

            var titleModifer = 'Today'; // or 'Tomorrow' or 'Yesterday'
            // Need to actually compute this ^

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            // Modify the title
            if (titleModifer) {
              instance.modules[2].title += ' for ' + titleModifer;
              instance.modules[3].title += ' for ' + titleModifer;
              instance.modules[4].title += ' for ' + titleModifer;
              instance.modules[5].title += ' for ' + titleModifer;
            }

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');
            instance.state.queryManagementKeys.positions = generateManagementId(instance.state.namespace, 'positions');
            instance.state.queryManagementKeys.workPeriods = generateManagementId(instance.state.namespace, 'workPeriods');
            instance.state.queryManagementKeys.users = generateManagementId(instance.state.namespace, 'users');

            // set the SubjectView to the primary query
            instance.modules[0].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);

            // Date query box query setup
            instance.modules[2].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[2].initSubscription(scope);

            // Position query box query setup
            instance.modules[3].setQueryManagementNameAndId(instance.state.queryManagementKeys.positions.key, instance.state.queryManagementKeys.positions.id);
            instance.modules[3].initSubscription(scope);

            // WorkPeriod query box query setup
            instance.modules[4].setQueryManagementNameAndId(instance.state.queryManagementKeys.workPeriods.key, instance.state.queryManagementKeys.workPeriods.id);
            instance.modules[4].initSubscription(scope);

            // Users query box query setup
            instance.modules[5].setQueryManagementNameAndId(instance.state.queryManagementKeys.users.key, instance.state.queryManagementKeys.users.id);
            instance.modules[5].initSubscription(scope);

            /**
             * Merges a base query with optional changes from the params.
             * @param  {object} opts Optional changes to the base query
             * @return {object}      Base query with the optional changes
             */
            function genBaseQuery(opts) {
              return lodash.merge({
                obj: 'date',
                dates: instance.state.dates
              }, opts || {});
            }

            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     // Update data; one or more
             *     date: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              var twx = TimeService.getDayTwixFromDate(newData.date);
              instance.state.dates = {
                start: twx.start,
                end: twx.end
              };

              // Set the queries with the new data
              instance.modules[2].setQuery(genBaseQuery());
              instance.modules[3].setQuery(genBaseQuery({
                obj: 'Position'
              }));
              instance.modules[4].setQuery(genBaseQuery({
                obj: 'WorkPeriod'
              }));
              instance.modules[5].setQuery(genBaseQuery({
                obj: 'User'
              }));
            };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-daterange': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-header',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              addHomeButton: true
            }, {
              name: 'layout-module-create',
              flags: {
                requiredContainer: 'layout-top-fixed',
                compactable: true,
                initialCompactableState: true
              }
            }, {
              // Date box
              name: 'layout-module-queryresults',
              title: 'Notes',
              flags: {
                collapsable: true,
                initiallyCollapsed: false,
                onlyAllow: 'date',
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              // Position box
              name: 'layout-module-queryresults',
              title: 'Notes on Positions',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'Position',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              name: 'layout-module-queryresults',
              title: 'Notes on Shifts',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'WorkPeriod',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              name: 'layout-module-queryresults',
              title: 'Notes on Users',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'User',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-fixed': 'overlay-measure',
                'layout-wrapper-queryresults': 'overlay-target',
                'layout-top-title': 'title'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            // Check for the required data
            if (!initData.dates && initData.start && initData.end) {
              console.error('Layout Configuration {layout-date}: Required Data Missing: start and end');
              return null;
            }

            instance.state = {
              namespace: scope.namespace
            };

            var titleModifer = 'Today'; // or 'Tomorrow' or 'Yesterday'
            // Need to actually compute this ^

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            // Modify the title
            if (titleModifer) {
              instance.modules[2].title += ' for ' + titleModifer;
              instance.modules[3].title += ' for ' + titleModifer;
              instance.modules[4].title += ' for ' + titleModifer;
              instance.modules[5].title += ' for ' + titleModifer;
            }

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');
            instance.state.queryManagementKeys.positions = generateManagementId(instance.state.namespace, 'positions');
            instance.state.queryManagementKeys.workPeriods = generateManagementId(instance.state.namespace, 'workPeriods');
            instance.state.queryManagementKeys.users = generateManagementId(instance.state.namespace, 'users');

            // set the SubjectView to the primary query
            instance.modules[0].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);

            // Date query box query setup
            instance.modules[2].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[2].initSubscription(scope);

            // Position query box query setup
            instance.modules[3].setQueryManagementNameAndId(instance.state.queryManagementKeys.positions.key, instance.state.queryManagementKeys.positions.id);
            instance.modules[3].initSubscription(scope);

            // WorkPeriod query box query setup
            instance.modules[4].setQueryManagementNameAndId(instance.state.queryManagementKeys.workPeriods.key, instance.state.queryManagementKeys.workPeriods.id);
            instance.modules[4].initSubscription(scope);

            // Users query box query setup
            instance.modules[5].setQueryManagementNameAndId(instance.state.queryManagementKeys.users.key, instance.state.queryManagementKeys.users.id);
            instance.modules[5].initSubscription(scope);

            /**
             * Merges a base query with optional changes from the params.
             * @param  {object} opts Optional changes to the base query
             * @return {object}      Base query with the optional changes
             */
            function genBaseQuery(opts) {
              return lodash.merge({
                obj: 'date',
                dates: instance.state.dates
              }, opts || {});
            }

            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     // Update data; one or more
             *     date: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              var start = TimeService.getDayTwixFromDate(newData.start);
              var end = TimeService.getDayTwixFromDate(newData.end);
              instance.state.dates = {
                start: start.start,
                end: end.end
              };

              // Set the queries with the new data
              instance.modules[2].setQuery(genBaseQuery());
              instance.modules[3].setQuery(genBaseQuery({
                obj: 'Position'
              }));
              instance.modules[4].setQuery(genBaseQuery({
                obj: 'WorkPeriod'
              }));
              instance.modules[5].setQuery(genBaseQuery({
                obj: 'User'
              }));
            };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-workperiod': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-header',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              addHomeButton: true
            }, {
              name: 'layout-module-create',
              flags: {
                requiredContainer: 'layout-top-fixed',
                compactable: true,
                initialCompactableState: true
              }
            }, {
              // WorkPeriod box
              name: 'layout-module-queryresults',
              title: 'Notes on this Shift',
              flags: {
                collapsable: true,
                initiallyCollapsed: false,
                onlyAllow: 'WorkPeriod',
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              // Position box
              name: 'layout-module-queryresults',
              title: 'Notes on Position for this Shift',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'Position',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }, {
              name: 'layout-module-queryresults',
              title: 'Notes on this Date',
              flags: {
                collapsable: true,
                initiallyCollapsed: true,
                onlyAllow: 'date',
                hideOnEmpty: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-fixed': 'overlay-measure',
                'layout-wrapper-queryresults': 'overlay-target',
                'layout-top-title': 'title'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            // Check for the required data
            if (!initData.workPeriodId) {
              console.error('Layout Configuration {layout-workperiod}: Required Data Missing: workPeriodId');
              return null;
            }

            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');
            instance.state.queryManagementKeys.positions = generateManagementId(instance.state.namespace, 'positions');
            instance.state.queryManagementKeys.date = generateManagementId(instance.state.namespace, 'date');

            // set the SubjectView to the primary query
            instance.modules[0].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);

            // Date query box query setup
            instance.modules[2].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[2].initSubscription(scope);

            // Date query box query setup
            instance.modules[3].setQueryManagementNameAndId(instance.state.queryManagementKeys.positions.key, instance.state.queryManagementKeys.positions.id);
            instance.modules[3].initSubscription(scope);

            // Date query box query setup
            instance.modules[4].setQueryManagementNameAndId(instance.state.queryManagementKeys.date.key, instance.state.queryManagementKeys.date.id);
            instance.modules[4].initSubscription(scope);

            /**
             * Merges a base query with optional changes from the params.
             * @param  {object} opts Optional changes to the base query
             * @return {object}      Base query with the optional changes
             */
            function genBaseQuery(opts) {
              return lodash.merge({
                obj: 'date',
                dates: instance.state.dates
              }, opts || {});
            }

            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     workPeriodId: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              WorkPeriodStore.getRecordById(newData.workPeriodId)
                .then(function(wp) {
                  var twx = TimeService.getDayTwixFromDate(wp.start_time);
                  instance.state.dates = {
                    start: twx.start,
                    end: twx.end
                  };

                  // Set the queries with the new data
                  instance.modules[2].setQuery(genBaseQuery({
                    obj: 'WorkPeriod',
                    obj_id: newData.workPeriodId
                  }));
                  instance.modules[3].setQuery(genBaseQuery({
                    obj: 'Position',
                    obj_id: wp.position.id
                  }));
                  instance.modules[4].setQuery(genBaseQuery());
                }, function(response) {
                  console.log('WorkPeriodStore load failed', response);
                });
            };

            return instance;
          }
        },
        'layout-position': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-header',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              addHomeButton: true
            }, {
              name: 'layout-module-create',
              flags: {
                requiredContainer: 'layout-top-fixed',
                compactable: true,
                initialCompactableState: true
              }
            }, {
              // Position box
              name: 'layout-module-queryresults',
              title: 'Notes on this Position',
              flags: {
                collapsable: true,
                initiallyCollapsed: false,
                onlyAllow: 'Position',
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-fixed': 'overlay-measure',
                'layout-wrapper-queryresults': 'overlay-target',
                'layout-top-title': 'title'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            // Check for the required data
            if (!initData.positionId) {
              console.error('Layout Configuration {layout-position}: Required Data Missing: positionId');
              return null;
            }

            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');

            // set the SubjectView to the primary query
            instance.modules[0].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);

            // WorkPeriod query box query setup
            instance.modules[2].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[2].initSubscription(scope);

            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     // Update data; one or more
             *     date: ...
             *     dates: { start: ...,  end: ... }
             *     positionId: ...
             *     workPeriodId: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              instance.modules[2].setQuery({
                obj: 'Position',
                obj_id: newData.positionId
              });
            };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-user': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-header',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              addHomeButton: true
            }, {
              name: 'layout-module-create',
              flags: {
                requiredContainer: 'layout-top-fixed',
                compactable: true,
                initialCompactableState: true
              }
            }, {
              // User box
              name: 'layout-module-queryresults',
              title: 'Notes on this User',
              flags: {
                collapsable: true,
                initiallyCollapsed: false,
                onlyAllow: 'User',
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-fixed': 'overlay-measure',
                'layout-wrapper-queryresults': 'overlay-target',
                'layout-top-title': 'title'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            // Check for the required data
            if (!initData.userId) {
              console.error('Layout Configuration {layout-user}: Required Data Missing: userId');
              return null;
            }

            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');

            // set the SubjectView to the primary query
            instance.modules[0].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);

            // WorkPeriod query box query setup
            instance.modules[2].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[2].initSubscription(scope);


            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     userId: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              instance.modules[2].subscription.setQuery({
                obj: 'User',
                obj_id: newData.userId
              });
            };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-employee-profile': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-create',
              flags: {
                requiredContainer: 'layout-top-fixed',
                compactable: true,
                initialCompactableState: true
              }
            }, {
              // User box
              name: 'layout-module-queryresults',
              title: 'Notes on this User',
              flags: {
                collapsable: true,
                initiallyCollapsed: false,
                onlyAllow: 'User',
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-fixed': 'overlay-measure',
                'layout-wrapper-queryresults': 'overlay-target',
                'layout-top-title': 'title'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            // Check for the required data
            if (!initData.userId) {
              console.error('Layout Configuration {layout-user}: Required Data Missing: userId');
              return null;
            }

            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');

            // set the SubjectView to the primary query
            instance.modules[0].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);

            // WorkPeriod query box query setup
            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].initSubscription(scope);


            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     userId: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              instance.modules[1].subscription.setQuery({
                obj: 'User',
                obj_id: newData.userId
              });
            };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-mostrecent': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-banner',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              text: 'Most Recent Notes',
              addHomeButton: true
            }, {
              name: 'layout-module-queryresults',
              title: '',
              flags: {
                collapsable: false,
                initiallyCollapsed: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-title': 'overlay-measure title',
                'layout-wrapper-queryresults': 'overlay-target'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            // Check for the required data
            // if (!initData.userId) {
            //   console.error('Layout Configuration {layout-user}: Required Data Missing: userId');
            //   return null;
            // }

            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');

            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].initSubscription(scope);


            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     userId: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              instance.modules[1].subscription.setQuery({
                obj: 'date',
                limit: 15
              });
            };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-learn': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-banner',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              text: 'Learn About Notes',
              addHomeButton: true
            }, {
              name: 'layout-module-template',
              flags: {
                requiredContainer: 'layout-learn-content'
              },
              templateUrl: 'views/notes/learn/learning.html'
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-title': 'overlay-measure title',
                'layout-learn-content': 'overlay-target'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });


            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     userId: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) { /* ... */ };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        },
        'layout-note': {
          instanceTemplate: {
            modules: [{
              name: 'layout-module-banner',
              flags: {
                requiredContainer: 'layout-top-title'
              },
              text: 'View Note',
              addHomeButton: true
            }, {
              name: 'layout-module-queryresults',
              title: 'View this Note',
              flags: {
                collapsable: false,
                requiredContainer: 'layout-wrapper-queryresults'
              }
            }],
            layoutFlags: {
              containerClasses: {
                'layout-top-title': 'overlay-measure title',
                'layout-wrapper-queryresults': 'overlay-target'
              }
            },
            defaultModuleFlags: []
          },
          configure: function(instance, initData, scope) {
            instance.state = {
              namespace: scope.namespace
            };

            lodash.each(instance.modules, function(module, idx) {
              instance.modules[idx] = moduleClasses[module.name].initModule(module, idx);
            });

            // an array for all of the various queryManagementKeys
            instance.state.queryManagementKeys = {};
            instance.state.queryManagementKeys.primary = generateManagementId(instance.state.namespace, 'primary');

            instance.modules[1].setQueryManagementNameAndId(instance.state.queryManagementKeys.primary.key, instance.state.queryManagementKeys.primary.id);
            instance.modules[1].initSubscription(scope);


            /**
             * Updates the layout instance with new incoming data.
             * The incoming data for the function should of the form:
             * {
             *   name: 'name-of-layout',
             *   data: {
             *     userId: ...
             *   }
             * }
             * @param  {object} newData Update data to update the layout with
             */
            instance.update = function(newData) {
              instance.modules[1].subscription.setQuery({
                id: newData.id
              });
            };

            /**
             * Generates HTML of the current instance of the layout.
             * @return {string} String of HTML to be rendered to the layout box
             */
            instance.render = function() {
              var containers = [];
              var html = '';

              /**
               * Initializes a container that is used as a wrapper for
               * multiple modules.
               * @param  {string} name Name of the container to be generated
               * @return {object}      Object containing an instance of a container
               */
              function initContainer(name) {
                var C = {name: name, modules: []};

                C.render = function() {
                  var html = '';

                  var classes = '';
                  if (lodash.has(instance.layoutFlags.containerClasses, lodash.kebabCase(C.name))) {
                    classes = instance.layoutFlags.containerClasses[lodash.kebabCase(C.name)];
                  }

                  if (name !== 'passthrough') {
                    html += '<div class="layout-container-generic layout-container-' + lodash.kebabCase(C.name) + ((classes.length > 0) ? (' ' + classes): '') + '">';
                  }

                  lodash.each(C.modules, function(module) {
                    html += module.render();
                  });

                  if (name !== 'passthrough') {
                    html += '</div>';
                  }

                  return html;
                };

                return C;
              }

              /**
               * Appended a module to the current container instance's
               * module array.
               * @param {string} containerName Name of the container to append to
               */
              function addModuleToContainer(containerName, module) {
                var idx = lodash.findIndex(containers, {name: containerName});

                if (idx > -1) {
                  containers[idx].modules.push(module);
                } else {
                  containers.push(initContainer(containerName));
                  addModuleToContainer(containerName, module);
                }
              }

              lodash.each(instance.modules, function(module) {
                if (module.flags.requiredContainer) {
                  addModuleToContainer(module.flags.requiredContainer, module);
                } else {
                  addModuleToContainer('passthrough', module);
                }
              });

              lodash.each(containers, function(container) {
                html += container.render();
              });

              return html;
            };

            return instance;
          }
        }
      };

      return {
        restrict: 'A',
        scope: {
          namespace: '@',
          initData: '=saNoteLayout',
          /*
            // Format of the initData attribute
            initData => {
              // Name of the layoutClass to use.
              name: 'test',

              // Custom template goes here. Would look exactly like
              // something from moduleClasses.
              template: { ... },

              // Namespace to use for generating management ids.
              namespace: 'note-overlay',

              // Module data fields that are required.
              // See moduleClass.requiredData at the top.
              data: {
                date: ...,
                positionId: ...,
                workPeriodId: ...
              }
            }
           */
        },
        link: function (scope, elem) {
          // Instance of the layout will be stored here
          scope.layout = {};
          scope.state = {
            htmlString: ''
          };

          /**
           * Initialize the desired layout by cloning the initial settings.
           * The custom configure() function is also called to set up the queries.
           * @param  {string} name  String name of the layout to initialize
           * @param  {obj} initData Data being passed through to the modules
           * @return {obj}          Instance of the layout class
           */
          function initLayout(name, initData) {
            return layoutClasses[name].configure(lodash.cloneDeep(layoutClasses[name].instanceTemplate), initData, scope);
          }

          /**
           * Verifies that a custom template is of the correct format to be
           * passed into the initLayout() function.
           * @param  {obj} template Object containing the layoutClass template data
           * @return {bool}         True if a valid template, false otherwise
           */
          function verifyCustomTemplate(template) {
            if (!template.instanceTemplate || !template.instanceTemplate.modules || !template.configure) {
              console.error('Custom moduleClass is missing module data or configure function.');
              return false;
            }

            // Make sure all the listed modules are valid modules.
            var validModules = _.keys(moduleClasses);
            _.each(template.modules, function(module) {
              if (!lodash.includes(validModules, module.name)) {
                console.error('Requested moduleClass does not exist:', module.name);
                return false;
              }
            });

            return true;
          }

          /**
           * Compile the layout view based on the initData coming in.
           */
          function compile() {
            var init = scope.initData;

            // If there is a template, add it to the moduleClasses dictionary
            if (init.template) {
              if (!verifyCustomTemplate(init.template)) {
                console.error('Custom template is of an invalid format.');
                return;
              }
              layoutClasses[init.name] = lodash.cloneDeep(init.template);
            }

            // Instantiate the class that we decide to use
            if (layoutClasses[init.name]) {
              scope.layout = initLayout(init.name, init.data);

              if (scope.layout.update) {
                scope.layout.update(init.data);
              }

              // Begin building the HTML string
              scope.state.htmlString += '<div class="sa-note-layout">';

              scope.state.htmlString += scope.layout.render();

              // Finish the HTML string and compile
              scope.state.htmlString += '</div>';
              $(elem).html($compile(scope.state.htmlString)(scope));
            } else {
              console.error('Nothing to compile. Try defining \'name\' or \'template\'.');
              return;
            }

          }

          compile();

          scope.$on('$destroy', function(x) {
            console.log('$destroy sa-note-layout', x);
          });

          scope.$on('sa:saNoteLayout:update', function(e, update) {
            if (update.namespace === scope.namespace && scope.layout && scope.layout.update) {
              scope.layout.update(update.payload.data);
            }
          });
        }
      };
    }]);
